export default __webpack_public_path__ + "static/media/digitalcard_receipt.5294ff18.svg";